import React from 'react';
export function ImageInner(props) {
    const { src, width, altText } = props;
    return (
    // eslint-disable-next-line jsx-a11y/alt-text
    React.createElement("img", { height: "auto", src: src, style: {
            border: '0',
            display: 'block',
            outline: 'none',
            textDecoration: 'none',
            height: 'auto',
            width: '100%',
            fontSize: '13px',
        }, width: width, alt: altText || '' }));
}
//# sourceMappingURL=image-inner.js.map